import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Popconfirm, Button, message } from 'antd';
// Services
import api from 'services/api';
import i18n from 'services/i18n';
// Utils
import { downloadFile } from 'utils/downloadFile';
// Components
import SelectTable from 'components/SelectTable';
import ModalEditor from './modalEditor';

const mapStateToProps = state => ({
  language: state.localization.lang,
});

@i18n('output')
@connect(mapStateToProps)
class SPTable extends PureComponent {
  static propTypes = {
    osceId: PropTypes.number.isRequired,
    sendEmail: PropTypes.bool,
    semesterId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
  };

  static defaultProps = {
    sendEmail: false,
  };

  constructor(props) {
    super();

    this.columns = [
      {
        title: props.translate('simulatedPatients'),
        dataIndex: 'text',
      },
    ];

    this.state = {
      data: [],
      selectedSPs: [],
      showEditor: false,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.osceId !== this.props.osceId) {
      this.loadData();
    }
  }

  loadData = () => {
    api.getSimulatedPatientsByOsce(this.props.osceId).then(res => {
      this.setState({ data: res.data.data });
    });
  };

  handleOpenEditor = () => this.setState({ showEditor: true });

  handleCloseEditor = () => this.setState({ showEditor: false });

  handleSelectSPs = selectedSPs => this.setState({ selectedSPs });

  handleloadPDF = template => {
    const data = {
      ids: this.state.selectedSPs,
      template,
    };

    const locale = this.props.language === 'en' ? 'ENGLISH' : 'GERMAN';

    api
      .printSimulatedPatientsSchedule(this.props.osceId, locale, data)
      .then(res =>
        downloadFile(res.data, `patient_schedule.pdf`, 'application/pdf'),
      )
      .catch(err => message.error(this.props.translate('all', 'error')));
  };

  handleSendEmailInvitation = () => {
    const data = { ids: this.state.selectedSPs };
    api
      .sendEmailInvitation(this.props.semesterId, 'patient', data)
      .then(res => message.success(this.props.translate('successMail')))
      .catch(err => message.error(this.props.translate('all', 'error')));
  };

  render() {
    const dataSource = this.state.data.map(item => ({
      ...item,
      key: item.patientId,
      text: `${item.lastName} ${item.firstName}`,
    }));

    let sendMailBtn = null;

    // Do we need to render send mail btn
    if (this.props.sendEmail) {
      // Popconfirm disabled property doesn't work
      // so if no selected sps just render button disabled
      if (this.state.selectedSPs.length > 0) {
        sendMailBtn = (
          <Popconfirm
            placement="bottom"
            title={this.props.translate('areYouSureSendEmail')}
            onConfirm={this.handleSendEmailInvitation}
          >
            <Button className="sendInvitations-btn">
              {this.props.translate('sendMail')}
            </Button>
          </Popconfirm>
        );
      } else {
        sendMailBtn = (
          <Button disabled className="sendInvitations-btn">
            {this.props.translate('sendMail')}
          </Button>
        );
      }
    }

    return (
      <React.Fragment>
        <ModalEditor
          type="schedule"
          name="patient"
          loadPDF={this.handleloadPDF}
          printCopiesParams={{ osceId: this.props.osceId }}
          show={this.state.showEditor}
          close={this.handleCloseEditor}
        />
        <Button
          className="sendInvitations-btn"
          disabled={!this.state.selectedSPs.length}
          onClick={this.handleOpenEditor}
        >
          {this.props.translate('printCopies')}
        </Button>
        {sendMailBtn}
        <div className="table-with-selection">
          <SelectTable
            columns={this.columns}
            dataSource={dataSource}
            onSelect={this.handleSelectSPs}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default SPTable;
